import * as React from 'react';
import ChevronRightOutlined from './chevron-right-outlined';
import ChevronRightFilled from './chevron-right-filled';
import type { IconCombinedProps } from './types';
const ChevronRightCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ChevronRightFilled ref={ref} {...rest} />;
  }
  return <ChevronRightOutlined ref={ref} {...rest} />;
});
export default ChevronRightCombined;